import { render } from "./AddCoupon.vue?vue&type=template&id=1158820c"
import script from "./AddCoupon.vue?vue&type=script&lang=js"
export * from "./AddCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__